import React, { useContext } from "react";
import Radio from "~/assets/js/components/Forms/Radio";
import i18n from "~/assets/js/Helpers/i18n";
import { ACTIONS, CheckoutContext } from "../../CheckoutProvider";
import PAYMENT_OPTIONS, {
    POTTSALAT_PAYMENT,
} from "~/assets/js/Helpers/paymentOptions";
import { fetchStoreData } from "~/assets/js/Api/storeApi.js";
import useAreaCookie from "~/assets/js/Helpers/hooks/useAreaCookie";
import { useCartContext } from "~/assets/js/global/cartContext";
import { hasReusableBowls } from "~/assets/js/Helpers/reusable-bowls-utils";

const NOT_ALLOWED = {
    FOR_COMPANY: [
        POTTSALAT_PAYMENT.COMPUTOP_SOFORT,
        POTTSALAT_PAYMENT.MONDU_INVOICE,
        POTTSALAT_PAYMENT.MONDU_DIRECT_DEBIT,
    ],
    FOR_PRIVATE: [
        POTTSALAT_PAYMENT.MONDU_INVOICE,
        POTTSALAT_PAYMENT.MONDU_DIRECT_DEBIT,
    ],
    FOR_REUSABLE_BOWLS: [
        POTTSALAT_PAYMENT.COMPUTOP_CREDITCARD,
        POTTSALAT_PAYMENT.MONDU_INVOICE,
        POTTSALAT_PAYMENT.MONDU_DIRECT_DEBIT,
        POTTSALAT_PAYMENT.COMPUTOP_SOFORT,
        POTTSALAT_PAYMENT.COMPUTOP_PAYDIREKT,
    ],
};

const PaymentSelectComponent = () => {
    const { actions, cart } = useCartContext();
    const cookie = useAreaCookie();
    const storeId = cookie?.area?.store_id;
    const { state: contextState, dispatch } = useContext(CheckoutContext);
    const { iconPath } = reactConfig;
    const { store } = fetchStoreData(storeId);
    const isReusableBowl = hasReusableBowls(cart?.items);

    const onPaymentSelect = async (selectedValue) => {
        await actions.updatePaymentMethod(selectedValue);
        dispatch({
            type: ACTIONS.UPDATE_PAYMENT,
            payload: selectedValue,
        });
    };

    const applyForCustomerTypeFilter = (paymentMethod) => {
        if (
            contextState.isCompanyOrder &&
            NOT_ALLOWED.FOR_COMPANY.includes(paymentMethod.value)
        ) {
            return false;
        }

        if (
            !contextState.isCompanyOrder &&
            NOT_ALLOWED.FOR_PRIVATE.includes(paymentMethod.value)
        ) {
            return false;
        }
        if (
            isReusableBowl &&
            NOT_ALLOWED.FOR_REUSABLE_BOWLS.includes(paymentMethod.value)
        ) {
            return false;
        }
        return true;
    };

    const applyPerStoreFilter = (paymentMethod) =>
        store && store.payment_methods.includes(paymentMethod.value);

    const paymentOptions = PAYMENT_OPTIONS.filter(applyPerStoreFilter).filter(
        applyForCustomerTypeFilter
    );

    const getPaymentMethod = (value) =>
        paymentOptions.find((paymentOption) => paymentOption.value === value);

    return (
        <>
            {paymentOptions.map((paymentOption) => {
                return (
                    <Radio
                        onValueChange={() => onPaymentSelect(paymentOption)}
                        bindName="paymentSelect"
                        value={paymentOption}
                        currentValue={getPaymentMethod(cart.payment?.method)}
                        customStyles="payment-selection"
                        key={paymentOption.value}
                    >
                        <>
                            <div className="text">
                                <span className="payment-selection__heading">
                                    {i18n.t(paymentOption.heading)}
                                </span>

                                <span className="payment-selection__text">
                                    {i18n.t(paymentOption.text)}
                                    {paymentOption.appendLinkUrl && (
                                        <>
                                            <a
                                                href={
                                                    paymentOption.appendLinkUrl
                                                }
                                                target={"_blank"}
                                                rel="noreferrer"
                                            >
                                                {i18n.t(
                                                    paymentOption.appendLinkText
                                                )}
                                            </a>
                                        </>
                                    )}
                                </span>
                            </div>
                            {paymentOption.icons.map((icon) => {
                                return (
                                    <div
                                        className="payment-selection__icon"
                                        key={icon}
                                    >
                                        <img
                                            src={`${iconPath}/${icon}`}
                                            alt="icon"
                                            key={icon}
                                        />
                                    </div>
                                );
                            })}
                        </>
                    </Radio>
                );
            })}
        </>
    );
};

export default PaymentSelectComponent;
